import { authorizedFetch, ErrorResponse } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface Insurance {
  id: string;
  name: string;
  status: number;
}

export async function fetchInsurances(
  includeInactive = false,
  complete = false,
  page = 1,
  pageSize = 1000
): Promise<Insurance[]> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/dental-insurances/?include_inactive=${includeInactive}&complete=${complete}&page=${page}&page_size=${pageSize}`
  );

  if (!response.ok) {
    throw new Error('Erro ao buscar Convênios');
  }

  const data = await response.json();
  return data.items ?? data;
}
